import { QueryClient } from '@tanstack/react-query';

import { api, BloodReportMetadata } from '@/api';

export async function loadPatient(bloodReport: BloodReportMetadata, queryClient: QueryClient) {
  if (bloodReport.prenuvoId) {
    const patient = await queryClient.ensureQueryData({
      queryFn: ({ signal }) =>
        api.patient.request.getPatient(
          { payload: { params: { prenuvoID: bloodReport.prenuvoId } } },
          signal,
        ),
      queryKey: [api.patient.KEY.GET_PATIENT, bloodReport.prenuvoId],
    });

    return patient;
  }

  return null;
}
